import { rowToPerson } from './roleHelpers.js'

// migrated 2026-04-27 to SDK entity routes:
//   app_settings → workspaceProject.companySettings (returns one row keyed
//                  by org; the legacy `app_settings` table was a kv list
//                  used in dev for `useRealAuth = false` — server collapses
//                  to a single object now so the transform unpacks fields
//                  rather than mapping rows).
//   people       → workspaceProject.people
export const appSettingsFetch = {
  method: 'select',
  from: 'workspaceProject.companySettings',
  as: '~/_settings',
  // companySettings.get returns one row { current_user_email, company_name, ... }
  // — guard the transform to also accept array-of-rows for back-compat.
  transform: (rowOrRows) => {
    const r = Array.isArray(rowOrRows)
      ? Object.fromEntries(rowOrRows.map((row) => [row.key, row.value]))
      : (rowOrRows || {})
    // Never fall back to another user's email — leaving it null/empty lets
    // the auth gate or page-level guards handle the missing identity, rather
    // than silently rendering Nika's data to whoever happens to load the
    // page before the auth subscription resolves.
    return {
      currentUserEmail: r.current_user_email || '',
      companyName: r.company_name || 'Symbols'
    }
  }
}

export const peopleFetch = {
  method: 'select',
  from: 'workspaceProject.people',
  order: 'name',
  as: '~/people',
  transform: (rows) => ({ people: (rows || []).map(rowToPerson) })
}

export const appPageBoilerplateFetch = [appSettingsFetch, peopleFetch]
